import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { PlanService } from "../../../../services/plan.service";
import { CommonService } from "../../../../services/common.service";

@Component({
  selector: "page-plan-detail",
  templateUrl: "./detail.component.html",
})
export class PagePlanDetailComponent implements OnInit {
  public $: any;
  public moment: any;
  public _: any;

  public planCode: any;
  public thePlan: any = {};
  public targetDay: string;
  public activatedStation: any = {};
  public bestPriceList: any = {};
  public divisionData: any = {};

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public location: Location,
    public commonService: CommonService,
    public planService: PlanService
  ) {
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.targetDay = this.moment().format("YYYY-MM-DD");
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET PLAN DATA */
    this.planCode = this.activatedRoute.snapshot.paramMap.get("planCode");
    let targetDay = this.activatedRoute.snapshot.queryParams.targetDay;
    if (
      targetDay &&
      this.moment(targetDay, "YYYY-MM-DD", true).isValid() === true
    ) {
      this.targetDay = targetDay;
    } else {
      this.location.replaceState(
        `${this.commonService.routePaths.pagePlanDetailNoParam}${this.planCode}?targetDay=${this.targetDay}`
      );
    }

    /* LOAD PLAN DETAILS */
    await this.loadPlanDetails();

    /* CHECK IF YOU ARE WANT TO VIEW STATION MAP */
    await this.checkForOpeningStationDetailModal();

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();

    /* SET PAGE TITLE */
    this.commonService.setTitle(
      `便詳細:${this.thePlan.course_name} | バスブックマーク`
    );

    /* HIDE LOADER */
    this.commonService.hidePageLoader();

    /* SET VIEWED */
    this.planService.setPlanViewed(this.thePlan);
  }

  async loadPlanDetails() {
    this.thePlan = await this.planService.getPlanDetail(
      this.planCode,
      this.targetDay,
      'plan_detail'
    );
    if (this._.isEmpty(this.thePlan)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanListNoParam
      );
    }

    /* CHECK IF TARGET DAY IS VALID */
    if (!this.thePlan.calendar.hasOwnProperty(this.targetDay)) {
      let today = Object.keys(
        this.thePlan.calendar
      )[0]; /* GET FIRST DAY OF CALENDAR */
      this.targetDay = today;

      if (this.targetDay) {
        this.location.replaceState(
          `${this.commonService.routePaths.pagePlanDetailNoParam}${this.planCode}?targetDay=${today}`
        );

        /* RE-LOAD PLAN DETAILS */
        await this.loadPlanDetails();
        return;
      }
    }

    /* UPDATE PLAN PRICE BY TARGET DAY */
    this.updatePlanPrices();

    /* CONVERT CALENDAR PRICE TO BEST PRICE FOR CALENDAR */
    this.bestPriceList = this.planService.getCalendarPrices(
      this.thePlan.calendar
    );

    /* SET CITY OF STATIONS UNIQUE */
    this.setStationCityListUnique();
  }

  setStationCityListUnique() {
    this.thePlan.uniqueStationCity = {
      departure: [],
      destination: [],
    };

    let temp = {
      departure: {},
      destination: {},
    };

    for (let item of this.thePlan.station_list) {
      let id = item.station_id ? item.station_id : item.station_code;
      if (item.station_type === 1) {
        temp.departure[item.city_name] = {
          id: id,
          city_name: item.city_name,
        };
      } else if (item.station_type === 2) {
        temp.destination[item.city_name] = {
          id: id,
          city_name: item.city_name,
        };
      }
    }

    for (let key in temp.departure) {
      this.thePlan.uniqueStationCity.departure.push(temp.departure[key]);
    }
    for (let key in temp.destination) {
      this.thePlan.uniqueStationCity.destination.push(temp.destination[key]);
    }
  }

  async checkForOpeningStationDetailModal() {
    let stationID = this.activatedRoute.snapshot.paramMap.get("stationID");
    let targetDay = this.activatedRoute.snapshot.paramMap.get("targetDay");

    if (targetDay) {
      this.targetDay = this.moment(targetDay).format("YYYY-MM-DD");
      this.onDateChanged({ date: this.targetDay });

      /* RE-LOAD PLAN DETAILS */
      await this.loadPlanDetails();
    }

    if (stationID && this.thePlan.station_list) {
      for (let station of this.thePlan.station_list) {
        if (
          station.station_code == stationID ||
          station.station_id == stationID
        ) {
          this.setActivatedStation(station);
          this.$("#mdl-map").modal();
          break;
        }
      }
    }
  }

  updatePlanPrices() {
    if (this.targetDay) {
      let priceData: any;
      if (this.thePlan.calendar.hasOwnProperty(this.targetDay)) {
        priceData = this.thePlan.calendar[this.targetDay];
      } else {
        /* NOT FOUND IN CALENDAR */
        /* SET TO THE FIRST DATE OF CALENDAR */
        let today = this.moment().format("YYYY-MM-DD");
        this.targetDay = today;
        priceData = this.thePlan.calendar[today];
      }

      this.thePlan.price = priceData.price;
      this.thePlan.price_child = priceData.price_child;
      this.thePlan.child_price = priceData.price_child;
      this.thePlan.enable_seat = priceData.last_seat;
    }

    if (this._.isEmpty(this.thePlan.calendar)) {
      this.thePlan.seat_available = 0;
    }
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  /* BELONGS TO CALENDAR */
  async onChooseDay(data: any) {
    if (this.bestPriceList.hasOwnProperty(data.date)) {
      this.targetDay = data.date;
      this.onDateChanged(data);

      /* CHECK SEAT AVAILABLE */
      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      /* LOAD PLAN DETAILS */
      await this.loadPlanDetails();

      if (this.thePlan.seat_available == 0) {
        /* SCROLL TO TOP */
        this.commonService.scrollToTop();
      }

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    }
  }

  onDateChanged(data: any) {
    this.location.replaceState(
      `${this.commonService.routePaths.pagePlanDetailNoParam}${this.thePlan.plan_code}?targetDay=${data.date}`
    );
  }
  /* END */

  isValidImageUrl(url: any): boolean {
    if (!url) return false;
    // 文字列型かチェック
    if (typeof url !== 'string') return false;
    // 簡易チェック（URL文字列と拡張子で確認）
    return /^https?:\/\/.+\.(jpg|jpeg|png|gif)$/i.test(url);
  }
  
  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
  
    // 二重でエラーにならないようにガード
    if (img.dataset.errorHandled) return;
  
    img.src = '/assets/images/common/no-image.png';
    img.dataset.errorHandled = 'true';
  }
  
  // バス画像URLを安全に取得するヘルパーメソッド
  getBusImageUrl(): string {
    if (!this.thePlan || !this.thePlan.bus_image_list) return '';
    if (!this.thePlan.bus_image_list.length) return '';
    if (!this.thePlan.bus_image_list[0]) return '';
    return this.thePlan.bus_image_list[0].bus_pic_url || '';
  }
  
  // バス画像のタイトルを安全に取得するヘルパーメソッド
  getBusImageTitle(): string {
    if (!this.thePlan || !this.thePlan.bus_image_list) return 'バス画像';
    if (!this.thePlan.bus_image_list.length) return 'バス画像';
    if (!this.thePlan.bus_image_list[0]) return 'バス画像';
    return this.thePlan.bus_image_list[0].title || 'バス画像';
  }
}
